$('#type').on('change', function () {
    $(this).parents('form').submit();
});
